export const MuiToggleButton = {
  root: {
    textTransform: 'none',
  },
};
